<template>
  <div id="app" class="pa-layout">
    <FlashMessage
      :hasFlashMessage="flashMessage.hasMessage"
      :message="flashMessage.message"
      :status="flashMessage.status"
      :hasControl="flashMessage.hasControl"
      :autoClose="flashMessage.autoClose"
      @closed="handleFlashMessageClose"
    />

    <GlobalLoading
      :hasGlobalLoading="isGlobalLoading"
    />
    
    <transition name="pa-simple-fade">
      <div class="pa-main-contents-container" ref="contentContainer" v-if="isActiveContentsContainer" :class="contentContainerClass">
        <GlobalHeaderForLoginedView ref="headerView" v-if="isLoginedView" />
        
        <transition name="simple-fade-app">
          <div class="pa-page-wrapper" v-show="isVisiblePageContent" ref="pageWrapper">
            <router-view/>
          </div>
        </transition>
      </div>
    </transition>

    <LandScapeProtector :isRequireProtect="isRequireLandscapeProtect" />

    <PATimesModal
     v-if="isLoginedView"
    />

    <CharacterDetailModal
      v-if="isLoginedView"
    />

    <PAPhotoSwipe
     v-if="isLoginedView"
    />

    <PACreateButton
     v-if="isLoginedView"
    />

    <PAConnectionEditor
     v-if="isLoginedView"
    />

    <!-- <PAParkNoteEditor
     v-if="isLoginedView"
    /> -->

    <PAParkNoteEditorNew
     v-if="isLoginedView"
    />
    
    <PAItemUseConfirmModal
     v-if="isLoginedView"
    />

    <PAConnectionManageModal
     v-if="isLoginedView"
    />

    <PAParkAreaInfomationModal
     v-if="isLoginedView"
    />

    <PACharacterModalInfomationModal
     v-if="isLoginedView"
    />

    <PAUserEmailNotificationRegistAlertModal
     v-if="isLoginedView"
    />

    <PATextEditorWarningModal
     v-if="isLoginedView"
    />

    <PATutorial
      v-if="isLoginedView"
    />
  </div>
</template>

<script>
import FlashMessage       from '@/components/Parts/FlashMessage/FlashMessage.vue';
import FlashMessageMixins from '@/components/Parts/FlashMessage/FlashMessageMixins.js';

import GlobalLoading       from '@/components/Parts/GlobalLoading/GlobalLoading.vue';
import GlobalLoadingMixins from '@/components/Parts/GlobalLoading/GlobalLoadingMixins.js';

import LandScapeProtector  from '@/components/Parts/LandScapeProtector/LandScapeProtector.vue';
import LandScapeProtectorMixins from '@/components/Parts/LandScapeProtector/LandScapeProtectorMixins.js';

import PATimesModal from '@/components/Parts/PATimesModal/PATimesModal.vue'

import GlobalHeaderForLoginedView from '@/components/Parts/GlobalHeaderForLoginedView/GlobalHeaderForLoginedView.vue';

import PAPhotoSwipe from '@/components/Parts/PAPhotoSwipe/PAPhotoSwipe.vue';

import CharacterDetailModal from '@/components/Parts/CharacterDetailModal/CharacterDetailModal.vue';

import PACreateButton from '@/components/Parts/PACreateButton/PACreateButton.vue'
import PAConnectionEditor from '@/components/Parts/PAConnectionEditor/PAConnectionEditorVersion2.vue'

// import PAParkNoteEditor   from '@/components/Parts/PAParkNoteEditor/PAParkNoteEditor.vue'
import PAParkNoteEditorNew from '@/components/Parts/PAParkNoteEditorNew/PAParkNoteEditorNew.vue'

import PAItemUseConfirmModal from '@/components/Parts/PAItemUseConfirmModal/PAItemUseConfirmModal.vue'

import PAConnectionManageModal from '@/components/Parts/PAConnectionManageModal/PAConnectionManageModal.vue'

import PAParkAreaInfomationModal from '@/components/Parts/PAParkAreaInfomationModal/PAParkAreaInfomationModal.vue'

import PACharacterModalInfomationModal from '@/components/Parts/PACharacterModalInfomationModal/PACharacterModalInfomationModal.vue'

import PAUserEmailNotificationRegistAlertModal from '@/components/Parts/PAUserEmailNotificationRegistAlertModal/PAUserEmailNotificationRegistAlertModal.vue'

import PATextEditorWarningModal from '@/components/Parts/PATextEditorWarningModal/PATextEditorWarningModal.vue'

import PATutorial from '@/components/Parts/PATutorial/PATutorial.vue'

import BodyNoScrollMixins from '@/mixins/BodyNoScrollMixins.js'
import BodyNoPullToRefreshAndroidMixins from '@/mixins/BodyNoPullToRefreshAndroidMixins.js'

export default {
  name        : 'appView',

  mixins      : [
    FlashMessageMixins,
    GlobalLoadingMixins,
    LandScapeProtectorMixins,
    BodyNoScrollMixins,
    BodyNoPullToRefreshAndroidMixins
  ],

  components  : {
    FlashMessage,
    GlobalLoading,
    LandScapeProtector,
    PATimesModal,
    GlobalHeaderForLoginedView,
    PAPhotoSwipe,
    PACreateButton,
    PAConnectionEditor,
    // PAParkNoteEditor,
    PAParkNoteEditorNew,
    PAItemUseConfirmModal,
    PAConnectionManageModal,
    PAParkAreaInfomationModal,
    PACharacterModalInfomationModal,
    PAUserEmailNotificationRegistAlertModal,
    PATextEditorWarningModal,

    CharacterDetailModal,

    PATutorial
  },

  data(){
    return {
      contentContainerClass     : [],
      // pageWrapperClass          : [],
      isActiveContentsContainer : false,
    };
  },

  computed : {
    isVisiblePageContent(){
      return this.$store.state.layouts.isVisiblePageContent;
    },

    mountedLayoutStyleName(){
      return this.$store.state.layouts.mountedLayoutStyleName;
    },

    isLoginedView(){
      return this.$store.state.layouts.loginedView;
    },
  },

  watch : {
    isLoginedView : {
      handler(value){
        if(value === true){
          this.contentContainerClass = ['pa-main-contents-container-logined'];
        }else{
          this.contentContainerClass = ['pa-main-contents-container-front'];
        }
      },
      immediate: true
    },

    mountedLayoutStyleName : {
      handler(value){
        switch(value){
          case 'front':
            this.handleEnterContentContainerForFront();
          break;

          case 'home':
            this.handleEnterContentContainer();
          break;
        }
      },
      immediate: true
    }
  },

  methods : {
    handleEnterContentContainerForFront(){
      this.$refs.pageWrapper.style.paddingBottom = 0;
      this.$refs.contentContainer.style.paddingTop = 0;
      this.$refs.contentContainer.style.height = 'auto';
    },
    
    handleEnterContentContainer(){
      if(!this.isLoginedView) return;

      let headerHeight = 0;
      let footerHeight = 0;
      let innerHeight  = 0;

      if(window.innerWidth <= 1023){
        headerHeight = this.$refs.headerView.$el.offsetHeight;
        footerHeight = this.$refs.headerView.$refs.iconBarField.$el.offsetHeight;

        innerHeight = window.innerHeight - (headerHeight + footerHeight);

        // スマホの場合、アイコン分をPaddingBottomしないとコンテンツが隠れる
        // 1px 減らさないと変な空白が出てしまう。
        this.$refs.pageWrapper.style.paddingBottom = (footerHeight-1)+'px';

        innerHeight++;
      }else{
        headerHeight = this.$refs.headerView.$el.offsetHeight;
        innerHeight  = window.innerHeight - headerHeight;
      }
      
      this.$refs.contentContainer.style.paddingTop  = headerHeight+'px';
      this.$refs.contentContainer.style.height      = innerHeight+'px';

      this.$store.dispatch({
        type  : 'layouts/updateMainContentHeight',
        value : innerHeight
      });
    }
  },

  created(){
    window.addEventListener('resize', this.handleEnterContentContainer);
  },

  beforeDestroy(){
    window.removeEventListener('resize', this.handleEnterContentContainer);
    
    if(this.autoCloseTimeoutId !== null){
      clearTimeout(this.autoCloseTimeoutId);
    }
  },
  
  mounted(){
    this.$store.dispatch({
      type  : 'layouts/updateIsMountedLoginedViewPage',
      value : false
    });

    this.$nextTick(() => {
      this.isActiveContentsContainer = true;
    });

    this.$on('mountedLoginedPage', () => {
      this.$store.dispatch({
        type  : 'layouts/updateIsMountedLoginedViewPage',
        value : true
      });
    });
  }

}
</script>

<style lang="scss">
// Disable the widescreen breakpoint
$widescreen-enabled: false;

// Disable the fullhd breakpoint
$fullhd-enabled: false;

@import "@/assets/scss/fonts.scss";
@import "@/assets/scss/mixins.scss";
@import "@/assets/scss/_variables.scss";
@import "~bulma/bulma.sass";
@import "@/assets/scss/pa-generals.scss";

@import "~vue-tour/dist/vue-tour.css";

.v-step{
  filter:none !important;
  -webkit-filter:none;
}

.simple-fade-app{
  &-enter-active{
    transition: opacity .5s;
  }

  &-leave-active{
    transition: none;
    opacity: 0;
  }
  
  &-enter, &-leave-to{
    opacity: 0;
  }
}

html, body.akibatrical{
  background-color:$body-background-primary;
  font-family: 'mplus-1m-medium';
  -webkit-touch-callout: none;

  &-noscroll{
    position: fixed;
  }

  &-no-pull-to-refresh-android{
    overscroll-behavior-y: none;
  }
}

.pa-layout{
  font-family: 'mplus-1m-medium';
  -webkit-touch-callout: none;
  
  button{
    font-family: 'mplus-1m-medium';

    &:focus {
      outline: none;
    }
    
    &:focus:not(:active), &.is-focused:not(:active){
      box-shadow: none;
    }
  }

  .pa-main-contents-container, .pa-page{
    box-sizing: content-box;
    background-color:$body-background-primary;
    font-family: 'mplus-1m-medium';
  }

  .pa-main-contents-container{
    .pa-page-wrapper{
      width:100vw;
    }

    &-logined{
      .pa-section{
        margin-top:1.5rem;
        border:4px solid #bda381;
        background-color: #cab090;
        padding-top:1rem;

        @media screen and (min-width: $desktop) {
          max-width:650px;
          margin:1.5rem auto 0;
        }

        &-transparent{
          border:0;
          background-color: transparent;
        }
      }
    }

    // &-front{
    //   .pa-section{
    //   }
    // }
  }
}
</style>
